export const ROUTE_PATH = '/clean/cleaner/invoice' as const
